import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AnalyticsData } from '../models/APIAnalyticsModels';
import {
  AppEngineDefinitionDto,
  AutoGeneratedModelPayload,
  BalanceTransferRequest,
  ClaimModel,
  ClientSettings,
  ContactUs,
  InferenceResponse,
  ModelDefinitionDto,
  ModelDefinitionDtoCompact,
  ModelRequestDto,
  ModelRequestSocialStatusInfo,
  ModelReview,
  ModelSearchResults,
  OrganizationInfoDto,
  PromoCodeRequest,
  RepositoryAccessRightDto,
  RepositoryDto,
  UserInfoDto,
} from '../models/APIModels';
// import { httpClient, httpClientForImage } from './HttpClient';
import clientUtils from '../Utils/clientUtils';
import { httpClient, httpClientForImage } from './Interceptor';

// export default ApiHelper

export const GetClientSettings = async (): Promise<AxiosResponse<ClientSettings>> => {
  return await httpClient.get<any, AxiosResponse<ClientSettings>>('/api/clients/Web');
};
export const HealthCheck = async (): Promise<AxiosResponse<string>> => {
  return await httpClient.get<any, AxiosResponse<string>>('/api/health');
};

const ApiHelper = {
  get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return httpClient.get<T, R>(url, config);
  },

  post<T = any, R = AxiosResponse<T>>(url: string, data?: T, config?: AxiosRequestConfig): Promise<R> {
    return httpClient.post<T, R>(url, data, config);
  },

  put<T = any, R = AxiosResponse<T>>(url: string, data?: T, config?: AxiosRequestConfig): Promise<R> {
    return httpClient.put<T, R>(url, data, config);
  },

  delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return httpClient.delete<T, R>(url, config);
  },
  async GetClientSettings(): Promise<AxiosResponse<ClientSettings>> {
    return await httpClient.get<any, AxiosResponse<ClientSettings>>('/api/clients/Web');
  },
  async HealthCheck(): Promise<AxiosResponse<string>> {
    return await httpClient.get<any, AxiosResponse<string>>('/api/health');
  },

  //#region <models>
  async GetModelById(modelId: string, chatbot:boolean = false, checkPermission: boolean=false): Promise<AxiosResponse<ModelDefinitionDto>> {
    let qurey = `/api/models/${modelId}?modelview=true&chatbot=${chatbot}&loadPermissions=${checkPermission}`;
    return await httpClient.get<any, AxiosResponse<ModelDefinitionDto>>(qurey);
  },
  async ApproveModel(modelId: string): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<ModelDefinitionDto>>(`/api/models/${modelId}/approve`);
  },
  async UpsertModel(data: ModelDefinitionDto): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<ModelDefinitionDto>>('/api/models', data);
  },
  async AutoGeneratedModel(data: AutoGeneratedModelPayload): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<ModelDefinitionDto>>('/api/tools/generatemodel?performUpsert=true', data);
  },
  async ThumbsUp(modelId: string): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<ModelDefinitionDto>>(`/api/tools/social/model/thumbsup/${modelId}`);
  },
  async DeleteModelById(modelId: string): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.delete<any, AxiosResponse<ModelDefinitionDto>>(`/api/models/${modelId}`);
  },
  async RejectModalById(modelId: string, reason: string): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<ModelDefinitionDto>>(`/api/models/${modelId}/reject?reason=${encodeURIComponent(reason)}`);
  },
  async GetModels(pagination: any): Promise<AxiosResponse<ModelDefinitionDto[]>> {
    let query = `/api/models/usermodels?page=${pagination.page}&pagecount=${pagination.rowsPerPage}`;
    if (pagination.visibility && pagination.visibility !== '') {
      query = query.concat('&',`visibility=${pagination.visibility}`);
    }
    if (pagination.repository && pagination.repository !== '') {
      query = query.concat('&',`repository=${pagination.repository}`);
    }
    if (pagination.modelType && pagination.modelType !== '') {
      query = query.concat('&',`modelType=${pagination.modelType}`);
    }
    query = encodeURI(query);
    return await httpClient.get<any, AxiosResponse<ModelDefinitionDto[]>>(query);
  },
  async Predict(data: any, modelId: string): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<any>>(`/api/predict/${modelId}`, data);
  },
  async PredictWithRequstId(data: any, modelId: string, requestId:string): Promise<AxiosResponse<InferenceResponse>> {
    return await httpClient.post<any, AxiosResponse<InferenceResponse>>(`/api/predict/${modelId}/${requestId}`, data);
  },
  async PredictStatusCheck(requestId): Promise<AxiosResponse<InferenceResponse>> {
    return await httpClient.get<any>(`/api/predict/status/${requestId}`);
  },
  async InitializeInference(modelId:string):Promise<AxiosResponse<InferenceResponse>> {
    return await httpClient.post<any>(`/api/predict/initialize/${modelId}`);
  },
  async GetUploadLinkForInference(requestId:string, fileName:string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/predict/upload/${requestId}/${fileName}`);
  },
  async GetDownloadLinkForInference(requestId:string, fileName:string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/predict/download/${requestId}/${fileName}`);
  },

  async SearchForModels(
    queryString:string
  ): Promise<AxiosResponse<ModelSearchResults>> {
    let url = `/api/models/search?${queryString}`;
    return await httpClient.get<any, AxiosResponse<ModelSearchResults>>(url);
  },
  async SearchModelsByUser(username: string, pageCount: number, page: number): Promise<AxiosResponse<ModelSearchResults>> {
    return await httpClient.get<any, AxiosResponse<ModelSearchResults>>(
      `/api/models/search?byuser=${username}&pagecount=${pageCount}&page=${page}`
    );
  },
  async GetUploadLinkInfo(id: string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/models/upload/${id}/MODELDESCRIPTION`);
  },
  async GetUploadLinkInfoForMAINMODEL(id: string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/models/upload/${id}/MAINMODEL`);
  },

  async GetScreenshotByUrl(url: string): Promise<AxiosResponse<any>> {
    return await httpClientForImage.get<any, AxiosResponse<any>>(`/api/web?url=${url}`);
  },

  async GetModelViewUrlByAlias(alias: any): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/clients/router/${alias}`);
  },

  //#endregion

  //#region <modelrequest>
  async SearchModelRequests(searchTerm: string, pageCount: number, page: number): Promise<AxiosResponse<ModelSearchResults>> {
    let url = `/api/modelrequest/search/BasicPublicPost?pagecount=${pageCount}&page=${page}`;
    if (!clientUtils.isEmpty(searchTerm)) {
      url = `/api/modelrequest/search/BasicPublicPost?searchterm=${searchTerm}&pagecount=${pageCount}&page=${page}`
    }


    return await httpClient.get<any, AxiosResponse<ModelSearchResults>>(
      url
    );
  },
  async GetRequestModelById(modelRequestId: string, loadRD?: boolean): Promise<AxiosResponse<ModelRequestDto>> {
    const url = loadRD ? `/api/modelrequest/${modelRequestId}?loadRD=true` : `/api/repository/${modelRequestId}`;
    return await httpClient.get<any, AxiosResponse<ModelRequestDto>>(url);
  },
  async UpsertRequestModel(data: ModelRequestDto): Promise<AxiosResponse<ModelRequestDto>> {
    return await httpClient.post<any, AxiosResponse<ModelRequestDto>>('/api/modelrequest', data);
  },
  async LikeModelRequest(requestId: string): Promise<AxiosResponse<ModelRequestSocialStatusInfo>> {
    return await httpClient.post<any, AxiosResponse<ModelRequestSocialStatusInfo>>(`/api/modelrequest/social/like/${requestId}`);
  },
  async GetUploadLinkInfoForModelRequest(id: string, fileName: string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/modelrequest/files/upload/${id}/${fileName}`);
  },
  async GetDownloadForModelRequestFile(id: string, fileName: string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/modelrequest/files/download/${id}/${fileName}`);
  },
  async DeleteModelRequest(id: string): Promise<AxiosResponse<any>> {
    return await httpClient.delete<any, AxiosResponse<any>>(`/api/modelrequest/${id}`);
  },
  async GetPopularModels(): Promise<AxiosResponse<ModelDefinitionDto>> {
    return await httpClient.get<any, AxiosResponse<ModelDefinitionDto>>('api/models/popular');
  },
  async GetHomePageStats(): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>('api/tools/platformstats');
  },

  //#endregion

  //#region <auth>
  async GetUserInfo(userData?: UserInfoDto): Promise<AxiosResponse<UserInfoDto>> {
    const path = '/api/auth?loadRD=true';
    return await httpClient.get<any, AxiosResponse<UserInfoDto>>(path);
  },
  async UpsertUserInfo(userData?: UserInfoDto): Promise<AxiosResponse<UserInfoDto>> {
    const path = '/api/auth?loadRD=true';
    return await httpClient.post<any, AxiosResponse<UserInfoDto>>(path, userData);
  },
  async SearchUser(searchKey: string): Promise<AxiosResponse<UserInfoDto>> {
    const path = `api/auth/search?loadRD=true&keyword=${searchKey}`;
    return await httpClient.get<any, AxiosResponse<any>>(path);
  },
  async forgetPassword(): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<any>>('/api/auth/resetpass');
  },
  //#endregion

  //#region <repository>
  async GetRepositories(): Promise<AxiosResponse<RepositoryDto[]>> {
    return await httpClient.get<any, AxiosResponse<RepositoryDto[]>>('/api/repository/search');
  },
  async UpsertRepository(data: RepositoryDto): Promise<AxiosResponse<RepositoryDto>> {
    return await httpClient.post<any, AxiosResponse<RepositoryDto>>('/api/repository', data);
  },

  async GetRepositoryById(repositoryId: string, loadRD?: boolean): Promise<AxiosResponse<RepositoryDto>> {
    const url = loadRD ? `/api/repository/${repositoryId}?loadRD=true` : `/api/repository/${repositoryId}`;
    return await httpClient.get<any, AxiosResponse<RepositoryDto>>(url);
  },
  async DeleteRepositoryById(repositoryId: string): Promise<AxiosResponse<RepositoryDto>> {
    return await httpClient.delete<any, AxiosResponse<RepositoryDto>>(`/api/repository/${repositoryId}`);
  },
  //#endregion

  //#region <organization>
  async GetAllOrganization(): Promise<AxiosResponse<OrganizationInfoDto[]>> {
    return await httpClient.get<any, AxiosResponse<OrganizationInfoDto[]>>('/api/organization');
  },
  async GetOrganizationById(organizationId: string, loadRD: boolean = true): Promise<AxiosResponse<OrganizationInfoDto>> {
    return await httpClient.get<any, AxiosResponse<OrganizationInfoDto>>(`/api/organization/${organizationId}?loadRD=${loadRD}`);
  },
  async UpsertOrganization(data: OrganizationInfoDto): Promise<AxiosResponse<OrganizationInfoDto>> {
    return await httpClient.post<any, AxiosResponse<OrganizationInfoDto>>('/api/organization', data);
  },
  //#endregion

  //#region <tools>
  async GetAnalytics(userAccountId: string): Promise<AxiosResponse<any>> {
    let path = '/api/tools/analytics';
    if(userAccountId && userAccountId!== ''){
      path = `/api/tools/analytics?accountId=${userAccountId}`;
    }
    return await httpClient.get<any, AxiosResponse<any>>(encodeURI(path));
  },
  async ContactUs(data: ContactUs): Promise<AxiosResponse<ContactUs>> {
    return await httpClient.post<any, AxiosResponse<ContactUs>>('/api/tools/contactus', data);
  },

  async ClaimModel(data: ClaimModel): Promise<AxiosResponse<ClaimModel>> {
    return await httpClient.post<any, AxiosResponse<ClaimModel>>('/api/tools/claimmodel', data);
  },

  async GetUserInfoByUserName(userName: string): Promise<AxiosResponse<UserInfoDto>> {
    const path = `api/tools/public/${userName}`;
    return await httpClient.get<any, AxiosResponse<UserInfoDto>>(path);
  },
  async GetAdminModelsReview(pageCount: number, page: number): Promise<AxiosResponse<ModelSearchResults>> {
    return await httpClient.get<any, AxiosResponse<ModelSearchResults>>(
      `/api/tools/admintools/review/models?pagecount=${pageCount}&page=${page}`
    );
  },
  async GetAdminModelRequestsReview(pageCount: number, page: number): Promise<AxiosResponse<ModelSearchResults>> {
    return await httpClient.get<any, AxiosResponse<ModelSearchResults>>(
      `/api/tools/admintools/review/modelrequests?pagecount=${pageCount}&page=${page}`
    );
  },
  //#endregion

  //#region <social>
  async GetReviewByUserId(modelId: string): Promise<AxiosResponse<ModelReview>> {
    return await httpClient.get<any, AxiosResponse<ModelReview>>(`/api/social/model/review/${modelId}/user`);
  },
  async UpsertReview(data: ModelReview, modelId: string): Promise<AxiosResponse<ModelReview>> {
    return await httpClient.post<any, AxiosResponse<ModelReview>>(`/api/social/model/review/${modelId}`, data);
  },
  async GetReviews(modelId: string): Promise<AxiosResponse<ModelReview[]>> {
    return await httpClient.get<any, AxiosResponse<ModelReview[]>>(`/api/social/model/review/${modelId}`);
  },
  //#endregion

  //#region <payments>
  async GetUserAccount(): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>('/api/payments/accounts');
  },
  async createOrder(data: any): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<ModelReview>>(`/api/payments/paypal/create_order`, data);
  },
  async completeOrder(data: any): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<ModelReview>>(`/api/payments/paypal/complete_order`, data);
  },
  async applyPromoCodeRequest(data: PromoCodeRequest): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<any>>('/api/payments/applypromo', data);
  },
  async balanceTranferRequest(data: BalanceTransferRequest): Promise<AxiosResponse<any>> {
    return await httpClient.post<any, AxiosResponse<any>>('/api/tools/balancetransfer', data);
  },
  //#endregion

  //#region <appengines>
  async GetUserEngines(): Promise<AxiosResponse<AppEngineDefinitionDto[]>> {
    let url = `/api/engines/userengines`;
   
    return await httpClient.get<any, AxiosResponse<AppEngineDefinitionDto[]>>(url);
  },
  async UpsertEngine(data: AppEngineDefinitionDto): Promise<AxiosResponse<AppEngineDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<AppEngineDefinitionDto>>('/api/engines', data);
  },
  async DeleteEngineById(engineId: string): Promise<AxiosResponse<AppEngineDefinitionDto>> {
    return await httpClient.delete<any, AxiosResponse<AppEngineDefinitionDto>>(`/api/engines/${engineId}`);
  },
  async GetEngineById(engineId: string, loadRD?: boolean): Promise<AxiosResponse<AppEngineDefinitionDto>> {
    const url = loadRD ? `/api/engines/${engineId}?loadRD=true` : `/api/engines/${engineId}`;
    return await httpClient.get<any, AxiosResponse<AppEngineDefinitionDto>>(url);
  },
  async GetUploadLinkForEngine(id: string, type, fileName:string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/engines/upload/${id}/${type}?fileName=${fileName}`);
  },
  async GetDownloadEngineFileLink(id: any, type, fileName:string): Promise<AxiosResponse<any>> {
    return await httpClient.get<any, AxiosResponse<any>>(`/api/engines/download/${id}/${type}?fileName=${fileName}`);
  },
  async DeployAppEngine(engineId:string): Promise<AxiosResponse<AppEngineDefinitionDto>> {
    return await httpClient.post<any, AxiosResponse<AppEngineDefinitionDto>>(`/api/engines/${engineId}/deploy`);
  },

  //#endregion
};

export { ApiHelper };
